var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.columnCount),function(n){return _c('div',{key:n,ref:"columns",refInFor:true,staticClass:"column"},_vm._l((_vm.getItemsForColumn(n)),function(item,index){return _c('div',{key:index,staticClass:"item"},[_vm._t("default",null,{"img":item})],2)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }